import { Injectable, Injector } from '@angular/core';

import { BaseReportService } from './reportBase.service';
import { SummaryService } from './summary.service';
import { SmsSentMessagesService } from './smsSentMessages.service';

import type { IGetReportData, TReportOptions } from '@shared/models';

@Injectable()
export class ReportSmsDetailService extends BaseReportService implements IGetReportData {
    // private options: TReportOptions;
    private summaryService: SummaryService;
    private smsSentMessagesService: SmsSentMessagesService;

    constructor(injector: Injector) {
        super(injector);
        this.summaryService = injector.get(SummaryService);
        this.smsSentMessagesService = injector.get(SmsSentMessagesService);
    }

    // public initialize(options: TReportOptions) {
    //     this.options = options;
    // }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];
        let numSmsMessages = 0;
        let reportColValues: any;

        const obj = await this.summaryService.getSmsByDateRange(this.options.startingDate!, this.options.endingDate!);
        // const allSmsUids = this.summaryService.extractUidsFromSms(allSms);
        const uids = obj?.uids;

        for (const uid of uids!) {
            const sms = await this.smsSentMessagesService.getByUid(uid);

            if (sms) {
                const maxLength = 30;
                const sentDate = this.formatDate(sms.sentToCustomerDate!);
                const sentTime = this.formatTime(sms.sentToCustomerDate!);
                const customerName = sms.customerName;
                const cellPhone = this.utilsService.maskPhoneNumber(sms.toNumber!);
                const type = sms.smsType;
                const message = this.truncateWithEllipsis(sms.message!, maxLength);

                reportColValues = [sentDate, sentTime, customerName, cellPhone, type, message];
                const rowInfo = this.buildRowInfo(reportColValues, 'data');
                allRows.push(rowInfo);
                ++numSmsMessages;
            }
        }

        // Tack on the summary totals.
        allRows.push(this.buildRowInfo(['Responses: ' + numSmsMessages.toString()], 'data', 'subtotal'));

        // Tack on the summary totals.
        allRows.push(this.buildRowInfo(['Total Messages: ' + uids?.length.toString()], 'summary'));
        allRows.push(undefined);
        const reportData = { 'data': allRows };
        return reportData;
    }
}
